import { DataLayerEventPayload, EventPayload } from './types'

export function transformEventPayload(eventPayload: EventPayload): DataLayerEventPayload {
    const event: DataLayerEventPayload = {}

    // Add predefined keys to event.
    if (eventPayload.action) {
        event.ga_eventAction = eventPayload.action
        delete eventPayload.action
    }
    if (eventPayload.category) {
        event.ga_eventCategory = eventPayload.category
        delete eventPayload.category
    }
    if (eventPayload.label) {
        event.ga_eventLabel = eventPayload.label
        delete eventPayload.label
    }
    if (eventPayload.value) {
        event.ga_eventValue = eventPayload.value
        delete eventPayload.value
    }

    // Add remaining keys to event.
    Object.entries(eventPayload).forEach(([key, value]) => (event[key] = value))

    return event
}

/**
 * Browsers native implementation of SHA-256 hashing.
 * Equivalent to Node.js: createHash('sha256').update(text).digest('hex')
 */
export async function hashEmail(email: string): Promise<string> {
    const encoder = new TextEncoder()
    const data = encoder.encode(email.trim().toLowerCase())
    const hashBuffer = await globalThis.crypto.subtle.digest('SHA-256', data)
    const hashArray = [...new Uint8Array(hashBuffer)]
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('')
    return hashHex
}
